import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WalletItemPassport } from "../../../store/common";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import { useForm } from "react-hook-form";
import { countryList } from "../../../util/CommonLists";
import { getFlowByName } from "../../../config/FlowName";
import * as NextStepFlowAction from "../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../store";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { PATTERNS } from "../../../util/patterns";
import { isValidDate } from "../../../util/common";
import { useTranslation } from "react-i18next";

const PassportDialog: React.FunctionComponent<{ requestDataCallback(): void; walletItem: WalletItemPassport; isNew: boolean; closeDialog(): void }> = (props) => {
  const { t: tLang, i18n: i18nLang } = useTranslation();
  const [isLoading, setisLoading] = useState(false);

  const dispatch = useDispatch();
  const lostWalletFlow = useSelector((state: ApplicationState) => getFlowByName(state, "LOST-WALLET-ASSISTANCE"));
  const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
  const [passport, setPassport] = useState(props.walletItem);
  const [errorMsg, seterrorMsg] = useState("");
  const [hasError, setHasError] = useState(false);

  const [dateOfBirth, setDateOfBirth] = useState({
    birthMonth: props.walletItem.dateOfBirth ? props.walletItem.dateOfBirth.trim().split("/")[0] : "",
    birthDay: props.walletItem.dateOfBirth ? props.walletItem.dateOfBirth.trim().split("/")[1] : "",
    birthYear: props.walletItem.dateOfBirth ? props.walletItem.dateOfBirth.trim().split("/")[2] : "",
  });

  const [issueDate, setIssueDate] = useState({
    issueMonth: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[0] : "",
    issueDay: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[1] : "",
    issueYear: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[2] : "",
  });

  const [expirationDate, setExpirationDate] = useState({
    expirationMonth: props.walletItem.expiryDate ? props.walletItem.expiryDate.trim().split("/")[0] : "",
    expirationDay: props.walletItem.expiryDate ? props.walletItem.expiryDate.trim().split("/")[1] : "",
    expirationYear: props.walletItem.expiryDate ? props.walletItem.expiryDate.trim().split("/")[2] : "",
  });

  const months = [
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.jan"), value: "01" },
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.feb"), value: "02" },
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.mar"), value: "03" },
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.apr"), value: "04" },
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.may"), value: "05" },
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.jun"), value: "06" },
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.jul"), value: "07" },
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.aug"), value: "08" },
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.sep"), value: "09" },
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.oct"), value: "10" },
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.nov"), value: "11" },
    { name: tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonthList.dec"), value: "12" },
  ];

  /**Validation with react-hook-form ***/
  const { register, errors, formState, handleSubmit, getValues } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
  });

  const { isValid, isSubmitting } = formState;

  useEffect(() => {
    if (dateOfBirth) {
      if (
        dateOfBirth.birthDay &&
        dateOfBirth.birthDay.length > 0 &&
        dateOfBirth.birthMonth &&
        dateOfBirth.birthMonth.length > 0 &&
        dateOfBirth.birthYear &&
        dateOfBirth.birthYear.length > 0
      ) {
        setPassport({ ...passport, dateOfBirth: dateOfBirth.birthMonth + "/" + dateOfBirth.birthDay + "/" + dateOfBirth.birthYear });
      } else {
        setPassport({
          ...passport,
          dateOfBirth: undefined,
        });
      }
    }
  }, [dateOfBirth]);

  useEffect(() => {
    if (issueDate) {
      if (
        issueDate.issueDay &&
        issueDate.issueDay.length > 0 &&
        issueDate.issueMonth &&
        issueDate.issueMonth.length > 0 &&
        issueDate.issueYear &&
        issueDate.issueYear.length > 0
      ) {
        setPassport({ ...passport, issueDate: issueDate.issueMonth + "/" + issueDate.issueDay + "/" + issueDate.issueYear });
      } else {
        setPassport({
          ...passport,
          issueDate: undefined,
        });
      }
    }
  }, [issueDate]);

  useEffect(() => {
    if (expirationDate) {
      if (
        expirationDate.expirationDay &&
        expirationDate.expirationDay.length > 0 &&
        expirationDate.expirationMonth &&
        expirationDate.expirationMonth.length > 0 &&
        expirationDate.expirationYear &&
        expirationDate.expirationYear.length > 0
      ) {
        setPassport({ ...passport, expiryDate: expirationDate.expirationMonth + "/" + expirationDate.expirationDay + "/" + expirationDate.expirationYear });
      } else {
        setPassport({
          ...passport,
          expiryDate: undefined,
        });
      }
    }
  }, [expirationDate]);

  function onDobChangeHandler(event: any) {
    setHasError(false);
    const elName = event.currentTarget.name;
    setDateOfBirth({ ...dateOfBirth, [elName as string]: event.currentTarget.value });
  }

  function onIssueDateChangeHandler(event: any) {
    setHasError(false);
    const elName = event.currentTarget.name;
    setIssueDate({ ...issueDate, [elName as string]: event.currentTarget.value });

    elName === 'issueYear' && setExpirationDate({ ...expirationDate, expirationYear: (Number(event.currentTarget.value) + 10).toString() })

  }




  function onExpirationDateChangeHandler(event: any) {
    setHasError(false);
    const elName = event.currentTarget.name;
    setExpirationDate({ ...expirationDate, [elName as string]: event.currentTarget.value });
  }

  const closeDialog = () => {
    document.body.classList.remove("no_scroll");
    props.closeDialog();
  };

  const refresWalletItem = () => {
    closeDialog();
    props.requestDataCallback();
  };

  const isFutureBirthDate: boolean =
    errors.birthDay &&
    errors.birthDay.type === "isFutureDate" &&
    errors.birthYear &&
    errors.birthYear.type === "isFutureDate" &&
    errors.birthMonth &&
    errors.birthMonth.type === "isFutureDate";
  const invalidBirthDate: boolean =
    errors.birthDay &&
    errors.birthDay.type === "invalidBirthDate" &&
    errors.birthYear &&
    errors.birthYear.type === "invalidBirthDate" &&
    errors.birthMonth &&
    errors.birthMonth.type === "invalidBirthDate";
  const invalidIssueDate: boolean =
    errors.issueDay &&
    errors.issueDay.type === "invalidIssueDate" &&
    errors.issueMonth &&
    errors.issueMonth.type === "invalidIssueDate" &&
    errors.issueYear &&
    errors.issueYear.type === "invalidIssueDate";
  const invalidExpirationDate: boolean =
    errors.expirationDay &&
    errors.expirationDay.type === "invalidExpirationDate" &&
    errors.expirationMonth &&
    errors.expirationMonth.type === "invalidExpirationDate" &&
    errors.expirationYear &&
    errors.expirationYear.type === "invalidExpirationDate";
  const isIssueExceedExpiration: boolean =
    errors.expirationDay &&
    errors.expirationDay.type === "isIssueExceedExpiration" &&
    errors.expirationMonth &&
    errors.expirationMonth.type === "isIssueExceedExpiration" &&
    errors.expirationYear &&
    errors.expirationYear.type === "isIssueExceedExpiration" &&
    errors.issueDay &&
    errors.issueDay.type === "isIssueExceedExpiration" &&
    errors.issueMonth &&
    errors.issueMonth.type === "isIssueExceedExpiration" &&
    errors.issueYear &&
    errors.issueYear.type === "isIssueExceedExpiration";

  const checkExpirationDateExceedIssueDate = () => {
    if (invalidIssueDate) return true;
    if (invalidExpirationDate) return true;

    const expirationYear = getValues("expirationYear") ? getValues("expirationYear") : "";
    const expirationMonth = getValues("expirationMonth") ? getValues("expirationMonth") : "";
    const expirationDay = getValues("expirationDay") ? getValues("expirationDay") : "";

    if (!expirationYear && !expirationMonth && !expirationDay) {
      return true;
    }

    const issueYear = getValues("issueYear") ? getValues("issueYear") : "";
    const issueMonth = getValues("issueMonth") ? getValues("issueMonth") : "";
    const issueDay = getValues("issueDay") ? getValues("issueDay") : "";

    if (!issueYear && !issueMonth && !issueDay) {
      return true;
    }
    const isValidIssueDate = isValidDate({ day: issueDay, month: issueMonth, year: issueYear });
    const isValidExpirationDate = isValidDate({ day: expirationDay, month: expirationMonth, year: expirationYear });

    if (!isValidIssueDate || !isValidExpirationDate) {
      return true;
    }

    const issueDate = new Date(`${issueMonth}/${issueDay}/${issueYear}`);
    const expirationDate = new Date(`${expirationMonth}/${expirationDay}/${expirationYear}`);

    if (expirationDate > issueDate) return true;
    return false;
  };

  const validateBirthDate = {
    isFutureDate: () => {
      const birthYear = getValues("birthYear") ? getValues("birthYear") : "";
      const birthMonth = getValues("birthMonth") ? getValues("birthMonth") : "";
      const birthDay = getValues("birthDay") ? getValues("birthDay") : "";

      if (birthYear && birthMonth && birthDay) {
        const todaysDate = new Date();
        const birthDate = new Date(`${birthMonth}/${birthDay}/${birthYear}`);

        if (todaysDate < birthDate) {
          return false;
        }

        return true;
      }
      return true;
    },
    invalidBirthDate: () => {
      const birthYear = getValues("birthYear") ? getValues("birthYear") : "";
      const birthMonth = getValues("birthMonth") ? getValues("birthMonth") : "";
      const birthDay = getValues("birthDay") ? getValues("birthDay") : "";
      if (!birthYear && !birthMonth && !birthDay) {
        return true;
      }

      return isValidDate({ day: birthDay, month: birthMonth, year: birthYear });
    },
  };

  const validatePassportIssueDate = {
    invalidIssueDate: () => {
      const issueYear = getValues("issueYear") ? getValues("issueYear") : "";
      const issueMonth = getValues("issueMonth") ? getValues("issueMonth") : "";
      const issueDay = getValues("issueDay") ? getValues("issueDay") : "";
      if (!issueYear && !issueMonth && !issueDay) {
        return true;
      }

      return isValidDate({ day: issueDay, month: issueMonth, year: issueYear });
    },
    isIssueExceedExpiration: () => {
      return checkExpirationDateExceedIssueDate();
    },
  };

  const validatePassportExpirationDate = {
    invalidExpirationDate: () => {
      const expirationYear = getValues("expirationYear") ? getValues("expirationYear") : "";
      const expirationMonth = getValues("expirationMonth") ? getValues("expirationMonth") : "";
      const expirationDay = getValues("expirationDay") ? getValues("expirationDay") : "";
      if (!expirationYear && !expirationMonth && !expirationDay) {
        return true;
      }

      return isValidDate({ day: expirationDay, month: expirationMonth, year: expirationYear });
    },
    isIssueExceedExpiration: () => {
      return checkExpirationDateExceedIssueDate();
    },
  };

  function onChangeHandler(event: any) {
    setHasError(false);
    const elName = event.currentTarget.name;
    setPassport({ ...passport, [elName as string]: event.currentTarget.value });
  }

  const saveItem = () => {
    const requestBody = {
      "lost-wallet": {
        "lost-wallet-passport": passport,
      },
    };
    setisLoading(true);
    httpClient
      .sendRequest("POST", "api/lostWallet/" + (props.isNew ? "addNewWalletItem" : "updateWalletItem"), requestBody)
      .then((data) => {
        setisLoading(false);
        if (data.isSuccess) {
          if (lostWalletFlow && lostWalletFlow.flowStepStatus !== "COMPLETED") {
            completeGetStartedItem(lostWalletFlow.flowStepId, lostWalletFlow.flowName ? lostWalletFlow.flowName : " ");
          }
          Notification({
            type: "success",
            title: props.isNew
              ? tLang("identityVault.secureStorage.lostWallterWidget.passport.addToastTitle")
              : tLang("identityVault.secureStorage.lostWallterWidget.passport.updateToastTitle"),
            message: props.isNew
              ? tLang("identityVault.secureStorage.lostWallterWidget.passport.addToastMessage")
              : tLang("identityVault.secureStorage.lostWallterWidget.passport.updateToastMessage"),
          });
          refresWalletItem();
        } else if (data.hasError && data.errors.length > 0) {
          seterrorMsg(data.errors.join(", "));
          setHasError(true);
        } else {
          seterrorMsg(tLang("identityVault.secureStorage.lostWallterWidget.passport.unknownError"));
          setHasError(true);
        }
      })
      .catch(function (error) {
        setisLoading(false);
        Notification({
          type: "error",
          title: tLang("identityVault.secureStorage.lostWallterWidget.passport.errorToastTitle"),
          message: tLang("identityVault.secureStorage.lostWallterWidget.passport.errorToastMesage"),
          duration: 0,
        });
        closeDialog();
      });
  };

  const dateFields = [
    <div className="col-xs-4 col-no-gutter">
      <div className="form-row row">
        <div className="form-label sr-only col-xs-12 col-no-gutter">
          <label htmlFor="label-dob-day">Date of Birth Day</label>
        </div>
        <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
          <select
            ref={register({ validate: validateBirthDate })}
            name="birthDay"
            className="inputbox"
            id="label-dob-day"
            defaultValue={dateOfBirth.birthDay}
            onChange={onDobChangeHandler}
          >
            <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateDay")}</option>
            {Array(31)
              .fill(null)
              .map((value, index) => {
                return (
                  <option key={index + 1} value={index < 9 ? "0" + (index + 1) : index + 1}>
                    {index < 9 ? "0" + (index + 1) : index + 1}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
    </div>,
    <div className="col-xs-4 col-no-gutter">
      <div className="form-row row">
        <div className="form-label sr-only col-xs-12 col-no-gutter">
          <label htmlFor="label-dob-month1">Date of Birth Month</label>
        </div>
        <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
          <select
            ref={register({ validate: validateBirthDate })}
            name="birthMonth"
            className="inputbox"
            id="label-dob-month"
            defaultValue={dateOfBirth.birthMonth}
            onChange={onDobChangeHandler}
          >
            <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonth")}</option>
            {months.map((month) => {
              return (
                <option key={month.value} value={month.value}>
                  {month.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>,
    <div className="col-xs-4 col-no-gutter">
      <div className="form-row row">
        <div className="form-label sr-only col-xs-12 col-no-gutter">
          <label htmlFor="label-dob-year">Date of Birth Year</label>
        </div>
        <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
          <select
            ref={register({ validate: validateBirthDate })}
            name="birthYear"
            className="inputbox"
            id="label-dob-year"
            aria-labelledby="label-dob-year"
            defaultValue={dateOfBirth.birthYear}
            onChange={onDobChangeHandler}
          >
            <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateYear")}</option>
            {Array(115)
              .fill(null)
              .map((value, index) => {
                const optionValue = new Date().getFullYear() - index;
                return (
                  <option key={optionValue} value={optionValue}>
                    {optionValue}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
    </div>,
  ];

  const issueDateFields = [
    <div className="col-xs-4 col-no-gutter">
      <div className="form-row row">
        <div className="form-label sr-only col-xs-12 col-no-gutter">
          <label htmlFor="label-issue-day">Issue Day</label>
        </div>
        <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
          <select
            ref={register({ validate: validatePassportIssueDate })}
            name="issueDay"
            className="inputbox"
            id="label-issue-day"
            defaultValue={issueDate.issueDay}
            onChange={onIssueDateChangeHandler}
          >
            <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateDay")}</option>
            {Array(31)
              .fill(null)
              .map((value, index) => {
                return (
                  <option key={index + 1} value={index < 9 ? "0" + (index + 1) : index + 1}>
                    {index < 9 ? "0" + (index + 1) : index + 1}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
    </div>,
    <div className="col-xs-4 col-no-gutter">
      <div className="form-row row">
        <div className="form-label sr-only col-xs-12 col-no-gutter">
          <label htmlFor="label-issue-month1">Issue Month</label>
        </div>
        <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
          <select
            ref={register({ validate: validatePassportIssueDate })}
            name="issueMonth"
            className="inputbox"
            id="label-issue-month"
            defaultValue={issueDate.issueMonth}
            onChange={onIssueDateChangeHandler}
          >
            <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonth")}</option>
            {months.map((month) => {
              return (
                <option key={month.value} value={month.value}>
                  {month.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>,
    <div className="col-xs-4 col-no-gutter">
      <div className="form-row row">
        <div className="form-label sr-only col-xs-12 col-no-gutter">
          <label htmlFor="label-issue-year">Issue Year</label>
        </div>
        <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
          <select
            ref={register({ validate: validatePassportIssueDate })}
            name="issueYear"
            className="inputbox"
            id="label-issue-year"
            aria-labelledby="label-issue-year"
            defaultValue={issueDate.issueYear}
            onChange={onIssueDateChangeHandler}
          >
            <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateYear")}</option>
            {Array(100)
              .fill(null)
              .map((value, index) => {
                const optionValue = new Date().getFullYear() - index;
                return (
                  <option key={optionValue} value={optionValue}>
                    {optionValue}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
    </div>,
  ];

  const expiryDateFields = [
    <div className="col-xs-4 col-no-gutter">
      <div className="form-row row">
        <div className="form-label sr-only col-xs-12 col-no-gutter">
          <label htmlFor="label-expiration-day">Expiration Day</label>
        </div>
        <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
          <select
            ref={register({ validate: validatePassportExpirationDate })}
            name="expirationDay"
            className="inputbox"
            id="label-expiration-day"
            defaultValue={expirationDate.expirationDay}
            onChange={onExpirationDateChangeHandler}
          >
            <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateDay")}</option>
            {Array(31)
              .fill(null)
              .map((value, index) => {
                return (
                  <option key={index + 1} value={index < 9 ? "0" + (index + 1) : index + 1}>
                    {index < 9 ? "0" + (index + 1) : index + 1}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
    </div>,
    <div className="col-xs-4 col-no-gutter">
      <div className="form-row row">
        <div className="form-label sr-only col-xs-12 col-no-gutter">
          <label htmlFor="label-expiration-month1">Expiration Month</label>
        </div>
        <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
          <select
            ref={register({ validate: validatePassportExpirationDate })}
            name="expirationMonth"
            className="inputbox"
            id="label-expiration-month"
            defaultValue={expirationDate.expirationMonth}
            onChange={onExpirationDateChangeHandler}
          >
            <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateMonth")}</option>
            {months.map((month) => {
              return (
                <option key={month.value} value={month.value}>
                  {month.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>,
    <div className="col-xs-4 col-no-gutter">
      <div className="form-row row">
        <div className="form-label sr-only col-xs-12 col-no-gutter">
          <label htmlFor="label-expiration-year">Expiration Year</label>
        </div>
        <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
          <select
            ref={register({ validate: validatePassportExpirationDate })}
            name="expirationYear"
            className="inputbox"
            id="label-expiration-year"
            aria-labelledby="label-expiration-year"
            // defaultValue={expirationDate.expirationYear}
            value={expirationDate.expirationYear}
            onChange={onExpirationDateChangeHandler}
          >
            <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.dateYear")}</option>
            {Array(11)
              .fill(null)
              .map((value, index) => {
                const optionValue = issueDate.issueYear ? Number(issueDate.issueYear) + index : new Date().getFullYear() + index;
                // const optionValue =  new Date().getFullYear() + index;
                return (
                  <option key={optionValue} value={optionValue}>
                    {optionValue}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
    </div>,
  ];

  return (
    <React.Fragment>
      {!isLoading ? (
        <>
          <div className="dialog-header">
            <div className="dialog-icon">
              <em className={props.isNew ? "las la-plus" : "las la-edit"}></em>
            </div>
            <h1>
              {props.isNew
                ? tLang("identityVault.secureStorage.lostWallterWidget.passport.addLabel")
                : tLang("identityVault.secureStorage.lostWallterWidget.passport.editLabel")}{" "}
              {tLang("identityVault.secureStorage.lostWallterWidget.passport.title")}
            </h1>
          </div>

          <form onSubmit={handleSubmit(saveItem)} id="passport-info-form-container">
            <div className="dialog-body large-dialog-scroll">
              <div className={errors["passportNumber"] ? "form-row row status-error" : "form-row row"}>
                <div className="form-row inline row">
                  <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                    <label htmlFor="edit-passport-number">
                      {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.passportNumber")}{" "}
                      <span className="required" title="Mandatory">
                        *
                      </span>
                    </label>
                  </div>
                  <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                    <input
                      aria-required="true"
                      type="text"
                      className="inputbox"
                      id="edit-passport-number"
                      aria-labelledby="edit-passport-number"
                      name="passportNumber"
                      defaultValue={passport.passportNumber}
                      onChange={onChangeHandler}
                      ref={register({
                        required: true,
                        pattern: /^[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF]+$/,
                        minLength: 4,
                      })}
                      maxLength={30}
                    />
                    {errors.passportNumber && errors.passportNumber.type === "pattern" && (
                      <span className="form-error">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.passportNumber.pattern2")}
                      </span>
                    )}

                    {errors.passportNumber && errors.passportNumber.type === "minLength" && (
                      <span className="form-error">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.passportNumber.pattern")}
                      </span>
                    )}

                    {errors.passportNumber && errors.passportNumber.type === "required" && (
                      <span className="form-error">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.passportNumber.required")}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className={errors["firstName"] ? "form-row row status-error" : "form-row row"}>
                <div className="form-row inline row">
                  <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                    <label htmlFor="edit-first-name">
                      {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.firstName")}{" "}
                      <span className="required" title="Mandatory">
                        *
                      </span>
                    </label>
                  </div>
                  <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                    <input
                      aria-required="true"
                      type="text"
                      className="inputbox"
                      id="edit-first-name"
                      aria-labelledby="edit-first-name"
                      name="firstName"
                      defaultValue={passport.firstName}
                      onChange={onChangeHandler}
                      ref={register({
                        required: true,
                        pattern: PATTERNS.FIRSTNAME.pattern,
                      })}
                      maxLength={30}
                    />
                    {errors.firstName && errors.firstName.type === "pattern" && (
                      <span className="form-error">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.firstName.pattern")}
                      </span>
                    )}

                    {errors.firstName && errors.firstName.type === "required" && (
                      <span className="form-error">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.firstName.required")}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className={errors["middleName"] ? "form-row row status-error" : "form-row row"}>
                <div className="form-row inline row">
                  <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                    <label htmlFor="edit-middle-initial">
                      {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.middleInitial")}
                    </label>
                  </div>
                  <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                    <input
                      aria-required="true"
                      type="text"
                      className="inputbox"
                      id="edit-middle-initial"
                      aria-labelledby="edit-middle-initial"
                      name="middleName"
                      defaultValue={passport.middleName}
                      onChange={onChangeHandler}
                      ref={register({
                        pattern: PATTERNS.MIDDLE_INITIAL.pattern,
                      })}
                      maxLength={1}
                    />
                    {errors.middleName && errors.middleName.type === "pattern" && (
                      <span className="form-error">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.middleInitial.pattern")}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className={errors["lastName"] ? "form-row row status-error" : "form-row row"}>
                <div className="form-row inline row">
                  <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                    <label htmlFor="edit-last-name">
                      {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.lastName")}{" "}
                      <span className="required" title="Mandatory">
                        *
                      </span>
                    </label>
                  </div>
                  <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                    <input
                      aria-required="true"
                      type="text"
                      className="inputbox"
                      id="edit-last-name"
                      aria-labelledby="edit-last-name"
                      name="lastName"
                      defaultValue={passport.lastName}
                      onChange={onChangeHandler}
                      ref={register({
                        required: true,
                        pattern: PATTERNS.LASTNAME.pattern,
                      })}
                      maxLength={30}
                    />
                    {errors.lastName && errors.lastName.type === "pattern" && (
                      <span className="form-error">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.lastName.pattern")}
                      </span>
                    )}

                    {errors.lastName && errors.lastName.type === "required" && (
                      <span className="form-error">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.lastName.required")}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-row inline row">
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                  <label htmlFor="edit-suffix">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.suffix")}</label>
                </div>
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                  <select
                    className="inputbox"
                    id="edit-suffix"
                    aria-labelledby="edit-suffix"
                    name="suffix"
                    defaultValue={passport.suffix}
                    onChange={onChangeHandler}
                  >
                    <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.suffix")}</option>
                    <option value="Sr">Sr</option>
                    <option value="Jr">Jr</option>
                    <option value="II">II</option>
                    <option value="III">III</option>
                    <option value="IV">IV</option>
                  </select>
                </div>
              </div>

              <div className="form-row inline row">
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                  <label htmlFor="edit-sex">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.sex")}</label>
                </div>
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                  <select
                    className="inputbox"
                    id="edit-sex"
                    aria-labelledby="edit-sex"
                    name="sex"
                    defaultValue={passport.sex}
                    onChange={onChangeHandler}
                  >
                    <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.sex")}</option>
                    <option value="Male">
                      {tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.sexDropDownList.male")}
                    </option>
                    <option value="Female">
                      {tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.sexDropDownList.female")}
                    </option>
                    <option value="Other">
                      {tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.sexDropDownList.other")}
                    </option>
                  </select>
                </div>
              </div>

              <div className={errors["passportType"] ? "form-row row status-error" : "form-row row"}>
                <div className="form-row inline row">
                  <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                    <label htmlFor="edit-passport-type">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.type")}</label>
                  </div>
                  <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                    <select
                      className="inputbox"
                      id="edit-passport-type"
                      aria-labelledby="edit-passport-type"
                      name="passportType"
                      defaultValue={passport.passportType}
                      onChange={onChangeHandler}
                    >
                      <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.passport.dropdownHeaders.type")}</option>
                      <option value="P">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.dropdownPassportList.regular")}
                      </option>
                      <option value="G">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.dropdownPassportList.greencardHolder")}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-row inline row">
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                  <label htmlFor="label-address-country">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.country")}</label>
                </div>
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                  <select
                    className="inputbox"
                    id="label-address-country"
                    aria-labelledby="label-address-country"
                    name="issuingCountry"
                    defaultValue={passport.issuingCountry}
                    onChange={onChangeHandler}
                  >
                    {countryList.map((val: any) => (
                      <option key={val.code} value={val.code}>
                        {val.code === ""
                          ? tLang("identityVault.secureStorage.lostWallterWidget.passport.placeholder.selectCountry")
                          : val.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row inline row">
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                  <label htmlFor="edit-passport-code">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.code")}</label>
                </div>
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                  <input
                    type="text"
                    className="inputbox"
                    id="edit-passport-code"
                    aria-labelledby="edit-passport-code"
                    maxLength={30}
                    name="passportCode"
                    defaultValue={passport.passportCode}
                    onChange={onChangeHandler}
                  />
                </div>
              </div>

              <div className={`form-row inline row${(isFutureBirthDate || invalidBirthDate) && " status-error"}`}>
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                  <label htmlFor="label-dob-month">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.dob")}</label>
                </div>
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                  <div className="row ">
                    {i18nService.get("Country") == "US" ? (
                      <>
                        {dateFields[1]} {dateFields[0]} {dateFields[2]}{" "}
                      </>
                    ) : i18nService.get("Country") == "CA" || i18nService.get("Country") == "TW" ? (
                      <>
                        {dateFields[2]} {dateFields[1]} {dateFields[0]}{" "}
                      </>
                    ) : (
                      <>
                        {dateFields[0]} {dateFields[1]} {dateFields[2]}
                      </>
                    )}
                    {isFutureBirthDate && (
                      <span className="form-error">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.date.pattern2")}
                      </span>
                    )}

                    {invalidBirthDate && (
                      <span className="form-error">
                        {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.date.pattern2")}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-row inline row">
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                  <label htmlFor="edit-place-of-birth">
                    {tLang("identityVault.secureStorage.lostWallterWidget.passport.label.placeOfBirth")}
                  </label>
                </div>
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                  <input
                    type="text"
                    className="inputbox"
                    id="edit-place-of-birth"
                    aria-labelledby="edit-place-of-birth"
                    name="placeOfBirth"
                    defaultValue={passport.placeOfBirth}
                    onChange={onChangeHandler}
                  />
                </div>
              </div>

              <div className="form-row inline row">
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                  <label htmlFor="edit-nationality">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.nationality")}</label>
                </div>
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                  <input
                    type="text"
                    className="inputbox"
                    id="edit-nationality"
                    aria-labelledby="edit-nationality"
                    maxLength={30}
                    name="nationality"
                    defaultValue={passport.nationality}
                    onChange={onChangeHandler}
                  />
                </div>
              </div>

              <div className={`form-row inline row${invalidIssueDate && " status-error"}`}>
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                  <label htmlFor="label-issue-month">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.issueDate")}</label>
                </div>
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                  <div className="row ">
                    {i18nService.get("Country") == "US" ? (
                      <>
                        {issueDateFields[1]} {issueDateFields[0]} {issueDateFields[2]}{" "}
                      </>
                    ) : i18nService.get("Country") == "CA" || i18nService.get("Country") == "TW" ? (
                      <>
                        {issueDateFields[2]} {issueDateFields[1]} {issueDateFields[0]}{" "}
                      </>
                    ) : (
                      <>
                        {issueDateFields[0]} {issueDateFields[1]} {issueDateFields[2]}
                      </>
                    )}
                  </div>

                  {invalidIssueDate && (
                    <span className="form-error">
                      {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.date.pattern2")}
                    </span>
                  )}
                </div>
              </div>

              <div className={`form-row inline row${(invalidExpirationDate || isIssueExceedExpiration) && " status-error"}`}>
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                  <label htmlFor="label-expiration-month">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.expiryDate")}</label>
                </div>
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                  <div className="row ">
                    {i18nService.get("Country") == "US" ? (
                      <>
                        {expiryDateFields[1]} {expiryDateFields[0]} {expiryDateFields[2]}{" "}
                      </>
                    ) : i18nService.get("Country") == "CA" || i18nService.get("Country") == "TW" ? (
                      <>
                        {expiryDateFields[2]} {expiryDateFields[1]} {expiryDateFields[0]}{" "}
                      </>
                    ) : (
                      <>
                        {expiryDateFields[0]} {expiryDateFields[1]} {expiryDateFields[2]}
                      </>
                    )}
                  </div>

                  {invalidExpirationDate && (
                    <span className="form-error">
                      {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.date.pattern2")}
                    </span>
                  )}

                  {isIssueExceedExpiration && (
                    <span className="form-error">
                      {tLang("identityVault.secureStorage.lostWallterWidget.passport.validationMessage.date.pattern3")}
                    </span>
                  )}
                </div>
              </div>

              <div className="form-row inline row">
                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                  <label htmlFor="edit-notes">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.notes")}</label>
                </div>
                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                  <textarea
                    className="inputbox"
                    id="edit-notes"
                    aria-labelledby="edit-notes"
                    name="notes"
                    maxLength={500}
                    style={{ resize: "none" }}
                    placeholder=""
                    rows={6}
                    defaultValue={passport.notes}
                    onChange={onChangeHandler}
                  ></textarea>
                </div>
              </div>

              {hasError && (
                <div className="form-row inline row">
                  <div className="form-label col-xs-12 col-sm-4 col-no-gutter"></div>
                  <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                    <p className="form-error">{errorMsg}</p>
                  </div>
                </div>
              )}
            </div>

            <div className="dialog-footer">
              <div className="row between-xs">
                <div className="col-xs col-no-gutter flex-grow-null">
                  <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                    <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.cancelButtonText")}</span>
                  </button>
                </div>
                <div className="col-xs col-no-gutter flex-grow-null">
                  <button type="submit" className="btn-default btn-primary" disabled={isSubmitting}>
                    <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.passport.label.saveButtonText")}</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </>
      ) : (
        <div className="box loading"></div>
      )}
    </React.Fragment>
  );
};

export default PassportDialog;
